var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 form-group"},[_c('page-header',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('setting-files-dropzones',{attrs:{"climate-files-type":"office_rating_calculations"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }